import { ObjectId } from "@/types/object-id";
import { ApiEndpointBuilder } from "@/services/api/types";
import { usersApi } from ".";

const updateUserStatus = (builder: ApiEndpointBuilder) => {
  return builder.mutation<string, Request>({
    query: ({ userId, activateUser }) => ({
      url: `/users/${userId}/toggle-status`,
      method: "POST",
      body: { userId, activateUser },
    }),
    async onQueryStarted(args, { dispatch, queryFulfilled }) {
      const patchFetchResult = dispatch(
        usersApi.util.updateQueryData("searchUsers", {}, draftList => {
          return {
            ...draftList,
            data: [
              ...(draftList?.data ?? []).map(x =>
                x.id === args?.userId
                  ? {
                      ...x,
                      isActive: args.activateUser,
                    }
                  : x
              ),
            ],
          };
        })
      );

      try {
        await queryFulfilled;
      } catch (error) {
        console.error(error);
        patchFetchResult.undo();
      }
    },
  });
};

type Request = {
  userId?: ObjectId;
  activateUser?: boolean;
};

export default updateUserStatus;
